import { HashLink } from 'react-router-hash-link';
import GenespLI from './GenespLI';
import GenesProteinClass from './GenesProteinClass';
import GenesUniProt from './GenesUniProt';
import { isRelease263Enabled } from '@/config/release263Features';

function AboutAttributesGenes() {
  return (
    <div id="section41">
      <h3>Genes</h3>
      <p>
        <strong>Genes in DISGENET are annotated with: </strong>
      </p>
      <ul>
        <li className="bullet-item">
          The official gene symbol, from the{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="http://www.ncbi.nlm.nih.gov/gene/">
            NCBI
          </a>
        </li>
        <li className="bullet-item">
          The{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="http://www.ncbi.nlm.nih.gov/gene/">
            NCBI
          </a>{' '}
          Official Full Name
        </li>
        <li className="bullet-item">
          The{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="https://www.ensembl.org/">
            {' '}
            Ensembl
          </a>{' '}
          Gene identifier
        </li>
        <GenesUniProt />
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/docs?section=metrics&subsection=specificity" className="js-fix-scroll">
            Disease Specificity Index{' '}
          </HashLink>
          (DSI)
        </li>
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/docs?section=metrics&subsection=pleiotropy" className="js-fix-scroll">
            Disease Pleiotropy Index{' '}
          </HashLink>
          (DPI)
        </li>
        <li className="bullet-item">The number of diseases associated to the gene (N diseases)</li>
        <li className="bullet-item">The number of variants associated to the gene (N variants)</li>
        <GenespLI />
        {isRelease263Enabled && (
          <li className="bullet-item">
            GTP: MeSH disease class profile of the gene, with a TCES score per class.
          </li>
        )}
        <GenesProteinClass />
        <li className="bullet-item">
          The pathways are obtained from top-level pathways from{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="https://reactome.org/">
            Reactome
          </a>
          .
        </li>
        <li className="bullet-item">
          The pathways IDs are unique identifiers that correspond to specific biological pathways within the{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="https://reactome.org/">
            Reactome{' '}
          </a>
          database.
        </li>
        <li className="bullet-item">Gene Type: protein-coding, ncRNA, pseudo, other, biological-region, snoRNA, tRNA, snRNA, rRNA and scRNA.</li>
      </ul>
    </div>
  );
}
export default AboutAttributesGenes;
